import { render, staticRenderFns } from "./documenttree.vue?vue&type=template&id=1dd32a42"
import script from "./documenttree.vue?vue&type=script&lang=js"
export * from "./documenttree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports